import PropTypes from "prop-types";
import CustomDropdown from "../../../../components/DropDownComponent";
import { useRewampT } from "../../../localisation";
import FilterSelectControl from "./FilterSelectControl";

export default function FilterSingleSelectField({
  controlId,
  labelKey,
  label,
  options,
  value,
  onChange,
  compact,
  dropdownVariant,
  clearable,
  error,
  describedBy,
}) {
  const tRewamp = useRewampT();
  const resolvedLabel = label || (labelKey ? tRewamp(labelKey) : "");
  // Dropdown variant → rewamp Select on the trigger part (label comes from the cell); otherwise the
  // legacy CustomDropdown, untouched for its other consumers.
  if (dropdownVariant) {
    return (
      <FilterSelectControl
        controlId={controlId}
        ariaLabel={resolvedLabel}
        options={options}
        value={value}
        onChange={onChange}
        dropdownVariant={dropdownVariant}
        clearable={clearable}
        clearLabel={tRewamp("FILTER_ROW.CLEAR_FIELD", undefined, { label: resolvedLabel })}
        error={error}
        describedBy={describedBy}
      />
    );
  }
  return (
    <CustomDropdown
      label={resolvedLabel}
      translateLabel={false}
      options={options}
      prefilledValue={value}
      onChange={onChange}
      compact={compact}
    />
  );
}

FilterSingleSelectField.propTypes = {
  labelKey: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  compact: PropTypes.bool,
  controlId: PropTypes.string,
  dropdownVariant: PropTypes.string,
  clearable: PropTypes.bool,
  error: PropTypes.bool,
  describedBy: PropTypes.string,
};

FilterSingleSelectField.defaultProps = {
  controlId: undefined,
  dropdownVariant: undefined,
  labelKey: null,
  label: null,
  options: [],
  value: "",
  compact: false,
  clearable: false,
  error: false,
  describedBy: undefined,
};
